import { AppLayout } from "@/components/layout/app-layout";
import { PageHeader } from "@/components/layout/page-header";
import { SettingsTabs } from "@/components/settings/settings-tabs";
import { useMemo } from "react";
import { useAuth } from "@/contexts/auth-context";

const Settings = () => {
  const { organization } = useAuth();

  const organizationName = organization?.name ?? "Swiss Finance OS";

  const periodLabel = useMemo(() => {
    const now = new Date();
    const quarter = Math.floor(now.getMonth() / 3) + 1;
    return `Q${quarter} ${now.getFullYear()}`;
  }, []);

  return (
    <AppLayout>
        <PageHeader 
        title="Einstellungen"
        subtitle={`${organizationName} • ${periodLabel}`}
      />
      
      <main className="flex-1 p-page-padding lg:p-page-padding-lg">
        <SettingsTabs />
        </main>
    </AppLayout>
  );
};

export default Settings;